import React, { useState,useEffect } from "react";
import "../Styles/Edit_profile.css";
import Profile_img from "../Images/human_icon.jpg"
import api from "../Api.js"
import {showToast} from "./PopupMessage.jsx"

function EditProfile() {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    location: "",
  });
  const token = localStorage.getItem("accessToken");


  
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  useEffect(()=>{
    const getprofiledata = async()=>{
      try{
        const res = await api.get("/profile",
                  {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          }
        
        });
        console.log(res);
        if(res.data.status === true){
           showToast("Profile Fetched Successfully..","success");
           setFormData(res.data?.customer);
           localStorage.setItem("customer", JSON.stringify(res.data.customer));
        }

      }catch(err){
        console.log(err)
      }
    }
    getprofiledata();

  },[])

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await api.put("/profile", formData,
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          }
        }
      );

      console.log(res);
      if (res.data?.status === true) {
        showToast("Profile Updated Successfully..","success");
        // alert("Profile Updated Successfully..")
      }

    } catch (err) {
      console.log(err)
    }

  };


  return (
    <div className="editProfile_container">
      <h2 className="editProfile_title">Edit Profile</h2>

      <div className="editProfile_card">
        {/* Profile Image + Upload */}
        <div className="editProfile_topSection">
          <div className="editProfile_imageWrapper">

            <img
              src={Profile_img}
              alt="profile"
              className="editProfile_image"
            />
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: "center", alignItems: "center" }}>
              <button className="editProfile_uploadBtn">Upload new photo</button>
              <p className="editProfile_imgNote">
                At least 800 x 800 is recommended, JPG or PNG is allowed
              </p>
            </div>
            <div>


            </div>
          </div>

          <div className="editProfile_tripReminder">
            <button className="editProfile_tripBtn">Bali Trip in 3 days!</button>
          </div>
        </div>

        <hr className="editProfile_divider" />

        {/* Stats Section */}
        <div className="editProfile_stats">
          <div className="editProfile_statBox">
            <p>Trips Taken</p>
            <h3>12</h3>
          </div>
          <div className="editProfile_statBox">
            <p>Country Visited</p>
            <h3>7</h3>
          </div>
          <div className="editProfile_statBox">
            <p>Review Given</p>
            <h3>5</h3>
          </div>
        </div>

        {/* Form Section */}
        <form className="editProfile_form" onSubmit={handleSubmit}>
          <label>Full Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
          />

          <label>Phone no</label>
          <input
            type="text"
            name="mobile"
            value={formData.mobile}
            onChange={handleChange}
          />

          <label>E-mail</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
          />

          <label>Location</label>
          <input
            type="text"
            name="location"
            value={formData.location}
            onChange={handleChange}
          />

          <button type="submit" className="editProfile_saveBtn">
            Save Changes
          </button>
        </form>
      </div>
    </div>
  );
}

export default EditProfile;
